(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('@fdn/top_menu'), require('@fdn/search_input'), require('@fdn/button_login_signup'), require('@fdn/button_profile'), require('@fdn/icon_cta'), require('@fdn/profile_popup'), require('@fdn/bs_shimmer'), require('@fdn/sidebar'), require('@fdn/toast_cta')) :
  typeof define === 'function' && define.amd ? define('@fdn/navbar_header', ['react', '@fdn/top_menu', '@fdn/search_input', '@fdn/button_login_signup', '@fdn/button_profile', '@fdn/icon_cta', '@fdn/profile_popup', '@fdn/bs_shimmer', '@fdn/sidebar', '@fdn/toast_cta'], factory) :
  (global = global || self, global['@fdn/navbar_header'] = factory(global.React, global.TopMenu, global.SearchInput, global.ButtonLoginSignup, global.ButtonProfile, global.IconCTA, global.ProfilePopup, global.Shimmer, global.Sidebar, global.ToastCta));
}(this, (function (React, TopMenu, SearchInput, ButtonLoginSignup, ButtonProfile, IconCTA, ProfilePopup, Shimmer, Sidebar, ToastCta) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
  TopMenu = TopMenu && Object.prototype.hasOwnProperty.call(TopMenu, 'default') ? TopMenu['default'] : TopMenu;
  SearchInput = SearchInput && Object.prototype.hasOwnProperty.call(SearchInput, 'default') ? SearchInput['default'] : SearchInput;
  ButtonLoginSignup = ButtonLoginSignup && Object.prototype.hasOwnProperty.call(ButtonLoginSignup, 'default') ? ButtonLoginSignup['default'] : ButtonLoginSignup;
  ButtonProfile = ButtonProfile && Object.prototype.hasOwnProperty.call(ButtonProfile, 'default') ? ButtonProfile['default'] : ButtonProfile;
  IconCTA = IconCTA && Object.prototype.hasOwnProperty.call(IconCTA, 'default') ? IconCTA['default'] : IconCTA;
  ProfilePopup = ProfilePopup && Object.prototype.hasOwnProperty.call(ProfilePopup, 'default') ? ProfilePopup['default'] : ProfilePopup;
  Shimmer = Shimmer && Object.prototype.hasOwnProperty.call(Shimmer, 'default') ? Shimmer['default'] : Shimmer;
  Sidebar = Sidebar && Object.prototype.hasOwnProperty.call(Sidebar, 'default') ? Sidebar['default'] : Sidebar;
  ToastCta = ToastCta && Object.prototype.hasOwnProperty.call(ToastCta, 'default') ? ToastCta['default'] : ToastCta;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  var Desktop = function Desktop(props) {
    var _props$main_link;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "navbar-header-placeholder"
    }), /*#__PURE__*/React.createElement("div", {
      className: "navbar-header"
    }, props.eventImage && (props.eventURL ? /*#__PURE__*/React.createElement("a", {
      href: props.eventURL,
      className: "top-event-banner-url",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.eventImage,
      alt: "event banner",
      className: "top-event-banner-image"
    })) : /*#__PURE__*/React.createElement("img", {
      src: props.eventImage,
      alt: "event banner",
      className: "top-event-banner-image"
    })), !!props.menu ? /*#__PURE__*/React.createElement(TopMenu, {
      type: props.type,
      menu_width: props.nav_width,
      is_mobile: props.is_mobile,
      title_menu: props.menu.title_menu,
      menus: props.menu.menus,
      is_hidden: props.is_hide_top_menu,
      handleAlloExplorer: props.handleAlloExplorer
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "navbar-content-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "navbar-inner-content-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "main-logo-wrapper"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.logo_id,
      href: props.home_link,
      className: "ic-fd",
      "aria-label": "Main Logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.logo_img || 'https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-femaledaily.svg',
      alt: "Main Logo"
    })), /*#__PURE__*/React.createElement("style", null, "\n                .main-logo-wrapper {\n                  display: flex;\n                  align-items: center;\n                  // height: 44px;\n                  position: relative;\n                  // max-width: 180px;\n                }\n        \n                .main-logo-wrapper a {\n                  display: flex;\n                  cursor: pointer;\n                  font-size: 38.75px;\n                }\n        \n                .main-logo-wrapper a * {\n                  max-height: 30px;\n                  height: 30px;\n                }\n              ")), /*#__PURE__*/React.createElement("div", {
      className: "search-input-wrapper"
    }, /*#__PURE__*/React.createElement(SearchInput, {
      is_mobile: props.is_mobile,
      type: props.type,
      placeholder: props.search_placeholder,
      search_text: props.search_text,
      submit_search: props.submit_search,
      update_search_text: props.update_search_text,
      element_id_input: props.search_input_id,
      element_id_search_button: props.search_button_id,
      onBlur: props.onBlurInput,
      on_input: props.search_on_input,
      on_change: props.search_on_change,
      on_focus: props.search_on_focus,
      on_select: props.search_on_select,
      on_keyDown: props.search_on_keydown,
      on_click: props.search_on_click,
      on_doubleclick: props.search_on_doubleclick,
      on_mouseenter: props.search_on_mouseenter,
      on_mouseleave: props.search_on_mouseleave,
      on_mouseover: props.search_on_mouseover,
      on_mouseout: props.search_on_mouseout,
      on_copy: props.search_on_copy,
      on_cut: props.search_on_cut,
      on_paste: props.search_on_paste
    }), /*#__PURE__*/React.createElement("div", {
      className: "search-suggestion-wrapper".concat(props.searchWrapper ? ' show' : '')
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "search-wrapper__backdrop",
      onClick: props.close_search_wrapper
    }), /*#__PURE__*/React.createElement("div", {
      className: "search-wrapper__wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-wrapper"
    }, props.searchWrapper))))), /*#__PURE__*/React.createElement("div", {
      className: "header-right-menu"
    }, props.is_fetch_complete ? /*#__PURE__*/React.createElement(React.Fragment, null, !!props.self && !!props.self.id ? /*#__PURE__*/React.createElement("div", {
      className: "profile-menu-wrapper"
    }, /*#__PURE__*/React.createElement(ButtonProfile, {
      is_mobile: props.is_mobile,
      username: props.self.username,
      image: props.self.picture.large.replace('http:', ''),
      on_hover: props.show_popup_profile,
      on_click: props.is_show_popup_profile ? props.hide_popup_profile : props.show_popup_profile,
      on_hover_out: props.hover_out_profile
    }), /*#__PURE__*/React.createElement("div", {
      className: "profile-popup-wrapper".concat(!!props.is_show_popup_profile ? ' show' : ''),
      onMouseLeave: props.hide_popup_profile
    }, /*#__PURE__*/React.createElement(ProfilePopup, {
      is_mobile: props.is_mobile,
      fullname: props.self.fullname,
      profile_image: props.self.picture.large,
      email: props.self.email,
      is_verified: props.is_user_verified,
      profile_link: "".concat(props.profile_link),
      setting_link: "".concat(props.setting_link),
      onClickLogout: props.onClickLogout,
      logout_link: "".concat(props.logout_link),
      base_url: props.base_url,
      loggedInMenu: props.loggedInMenu,
      UrlRedirect: props.UrlRedirect,
      customContent: props.profilePopupCustomElement
    }))) : /*#__PURE__*/React.createElement(ButtonLoginSignup, {
      is_mobile: props.is_mobile,
      text: 'Login or Signup',
      link: props.sso_link,
      onClick: props.onClickLoginSignup,
      default_class: "",
      element_id: props.button_login_id || 'button_login',
      type: props.type
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shimmer, {
      id: "profile",
      height: "40px",
      width: "150px",
      margin: "0 10px 0 0"
    })), props.customIcons ? /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return props.handleClickCustomIcons(e);
      }
    }, props.customIcons.map(function (icon) {
      return icon;
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, props.isNewIcon ? /*#__PURE__*/React.createElement("a", {
      href: "".concat(props.shop_link, "/cart?action=show"),
      className: "new-icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-cart.svg",
      width: "14",
      className: "ic-object",
      alt: "ic-cart"
    })) : /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-cart",
      badge_count: props.total_cart_items,
      link: "".concat(props.shop_link, "/cart?action=show"),
      element_id: props.button_cart_id,
      type: props.type,
      aria_label: "Button Cart"
    }), !!props.self ? props.isNewIcon ? /*#__PURE__*/React.createElement("a", {
      className: "new-icon",
      href: "".concat(props.reviews_link, "/notification?tab=").concat(props.main_link.includes('talk') ? 'talks' : 'reviews')
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-notif.svg",
      width: "14",
      className: "ic-object",
      alt: "ic-notif"
    })) : /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-notif",
      badge_count: props.total_unread_notif,
      link: "".concat(props.reviews_link, "/notification?tab=").concat((_props$main_link = props.main_link) !== null && _props$main_link !== void 0 && _props$main_link.includes('talk') ? 'talks' : 'reviews'),
      element_id: props.button_notif_id,
      type: props.type,
      aria_label: "Button Notification"
    }) : null)))), !!props.childrenWrapper && /*#__PURE__*/React.createElement("div", {
      className: "child-component-wrapper"
    }, props.childrenWrapper), /*#__PURE__*/React.createElement("style", null, "\n\n          .ic-object {\n            pointer-events: none;\n            cursor: pointer;\n          } \n\n          .new-icon {\n            margin: 0 5px;\n            width: 36px;\n            height: 36px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: none;\n            background: none;\n            cursor: pointer;\n          }\n\n          .navbar-header-placeholder {\n            height: ".concat(props.nav_position === 'fixed' ? props.nav_height : '0', "px;\n            transition: all .2s ease;\n          }\n\n          .navbar-header {\n            ").concat(props.nav_position === 'fixed' ? "\n                position: fixed;\n                top: 0;\n                left: 0;\n                z-index: 3;\n                width: 100vw;\n                padding: 0;\n              " : "\n                position: relative;\n                width: 100vw;\n              ", "\n            box-shadow: 0px 4px 10px rgba(145, 158, 171, 0.1);\n          }\n\n          .navbar-content-wrapper {\n            width: 100%;\n            position: relative;\n            background-color: #FFF;\n          }\n    \n          .navbar-inner-content-wrapper {\n            display: flex;\n            align-items: center;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            max-width: ").concat(props.nav_width, ";\n            margin: 0 auto;\n            padding: 16px 15px;\n          }\n    \n          .search-input-wrapper {\n            width: 50%;\n            position: relative;\n          }\n    \n          .header-right-menu {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            max-width: calc(50% - 245px);\n          }\n    \n          .header-right-menu .btn-login,\n          .header-right-menu .profile-menu-wrapper,\n          .header-right-menu .header-cta-wrapper {\n            margin-right: 12px;\n          }\n\n          .header-right-menu .btn-login {\n            margin-left: auto;\n          }\n    \n          .header-right-menu  .header-cta-wrapper:nth-last-child(1) {\n            margin-right: 0;\n          }\n    \n          .profile-menu-wrapper {\n            display: flex;\n            align-items: center;\n            position: relative;\n            pointer-events: all;\n          }\n    \n          .profile-menu-wrapper .button-profile-wrapper {\n            z-index: 1;\n          }\n    \n          .profile-popup-wrapper {\n            position: absolute;\n            top: 100%;\n            z-index: 0;\n            pointer-events: none;\n            opacity: 0;\n            transition: opacity .2s ease;\n            min-width: 15em;\n            margin-left: -1em;\n            width: 100%;\n          }\n    \n          .profile-popup-wrapper.show {\n            z-index: 1;\n            opacity: 1;\n            pointer-events: all;\n          }\n\n          .search-suggestion-wrapper {\n            position: absolute;\n            width: 100%;\n            top: 100%;\n            margin-top: 12px;\n            display: none;\n          }\n          \n          .search-suggestion-wrapper.show {\n            display: block;\n          }\n          \n          .top-event-banner-url,\n          .top-event-banner-image {\n            display: block;\n            width: 100%;\n          }\n\n          .child-component-wrapper {\n            width: 100%;\n          }\n          .search-wrapper__wrapper {\n            width: 100%;\n            position: relative;\n            z-index: 3;\n            background: white;\n            padding-right : 8px;\n            box-sizing: border-box;\n            border-radius: 0px 0px 12px 12px;\n          }\n          .search-wrapper__backdrop {\n            width: 100vw;\n            height: 100vh;\n            position: fixed;\n            z-index: 3;\n            background: #000000;\n            opacity: 0.5;\n            left: 0;\n            box-sizing: border-box;\n          }\n          .search-wrapper {\n            background: transparent;\n            position: relative;\n            z-index: 3;\n            border-radius: 0px 0px 12px 12px;\n            max-height: calc(100vh - 184px);\n            overflow-y: auto;\n            overflow-x: hidden;\n          }\n          .search-wrapper::-webkit-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper::-webkit-scrollbar-track {\n            background: transparent;\n            border-color: white;\n          }\n          .search-wrapper::-webkit-scrollbar-thumb {\n            background: #D9D9D9;\n            border-radius:10px;\n          }\n          .search-wrapper::-moz-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper::-moz-scrollbar-track {\n            background: transparent;\n            border-radius:10px;\n          }\n          .search-wrapper::-moz-scrollbar-thumb {\n            background: #D9D9D9;\n            border-radius:10px;\n          }\n          .search-wrapper::-ms-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper::-ms-scrollbar-track {\n            background: transparent;\n            border-radius:10px;\n          }\n          .search-wrapper::-ms-scrollbar-thumb {\n            background: #D9D9D9;\n            border-radius:10px;\n          }\n        "))));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "navbar-header-placeholder"
    }), /*#__PURE__*/React.createElement("div", {
      className: "navbar-header".concat(props.show_toast_cta ? " show" : "")
    }, props.eventImage && (props.eventURL ? /*#__PURE__*/React.createElement("a", {
      href: props.eventURL,
      className: "top-event-banner-url",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.eventImage,
      alt: "event banner",
      className: "top-event-banner-image"
    })) : /*#__PURE__*/React.createElement("img", {
      src: props.eventImage,
      alt: "event banner",
      className: "top-event-banner-image"
    })), /*#__PURE__*/React.createElement(ToastCta, {
      show: props.show_toast_cta,
      handle_close_toast_cta: props.handle_close_toast_cta,
      text_toast_cta: props.text_toast_cta,
      element_id_btn_close_toast_cta: props.element_id_btn_close_toast_cta,
      element_id_btn_install_toast_cta: props.element_id_btn_install_toast_cta,
      url_play_store: props.url_play_store,
      url_apps_store: props.url_apps_store
    }), /*#__PURE__*/React.createElement("div", {
      className: "navbar-content-wrapper"
    }, props.is_show_search ? /*#__PURE__*/React.createElement("div", {
      className: "search-input-wrapper"
    }, /*#__PURE__*/React.createElement(SearchInput, {
      is_mobile: props.is_mobile,
      type: props.type,
      placeholder: props.search_placeholder,
      search_text: props.search_text,
      submit_search: props.submit_search,
      update_search_text: props.update_search_text,
      hide_search: props.hide_search,
      element_id_input: props.search_input_id,
      element_id_search_button: props.search_button_id,
      onBlur: props.onBlurInput,
      on_input: props.search_on_input,
      on_change: props.search_on_change,
      on_focus: props.search_on_focus,
      on_select: props.search_on_select,
      on_keyDown: props.search_on_keydown,
      on_click: props.search_on_click,
      on_doubleclick: props.search_on_doubleclick,
      on_mouseenter: props.search_on_mouseenter,
      on_mouseleave: props.search_on_mouseleave,
      on_mouseover: props.search_on_mouseover,
      on_mouseout: props.search_on_mouseout,
      on_copy: props.search_on_copy,
      on_cut: props.search_on_cut,
      on_paste: props.search_on_paste
    }), /*#__PURE__*/React.createElement("div", {
      className: "search-suggestion-wrapper".concat(props.searchWrapper ? ' show' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "search-wrapper__container"
    }, props.searchWrapper))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "burger-menu",
      onClick: props.toggle_sidebar
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-menu-left.svg",
      width: "18",
      alt: "ic-menu-left",
      className: "ic-object"
    })), /*#__PURE__*/React.createElement("div", {
      className: "main-logo-wrapper"
    }, /*#__PURE__*/React.createElement("a", {
      id: props.logo_id,
      href: props.home_link,
      "aria-label": "Main Logo"
    }, /*#__PURE__*/React.createElement("img", {
      src: props.logo_img || 'https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-femaledaily.svg',
      alt: "Main Logo"
    })), /*#__PURE__*/React.createElement("style", null, "\n                  .main-logo-wrapper {\n                    // width: 112.96px;\n                    overflow: hidden;\n                  }\n          \n                  .main-logo-wrapper a {\n                    display: flex;\n                    position: relative;\n                    font-size: 28px;\n                    height: 28px;\n                  }\n          \n                  .main-logo-wrapper a * {\n                    // max-width: 100%;\n                    max-height: 28px;\n                    height: 28px;\n                  }\n                ")), /*#__PURE__*/React.createElement("div", {
      className: "header-right-menu"
    }, props.customIcons ? /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        return props.handleClickCustomIcons(e);
      }
    }, props.customIcons.map(function (icon) {
      return icon;
    })) : !!props.self ? /*#__PURE__*/React.createElement("div", {
      className: "profile-menu-wrapper"
    }, props.isNewIcon ? /*#__PURE__*/React.createElement("div", {
      className: "new-list-icon"
    }, /*#__PURE__*/React.createElement("button", {
      className: "new-icon",
      onClick: function onClick() {
        return props.show_search();
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-search.svg",
      width: "12",
      alt: "ic-search",
      className: "ic-object"
    })), /*#__PURE__*/React.createElement("a", {
      href: "".concat(props.shop_link, "/cart?action=show"),
      className: "new-icon"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-cart.svg",
      width: "12",
      alt: "ic-cart",
      className: "ic-object"
    })), /*#__PURE__*/React.createElement("a", {
      className: "new-icon",
      href: "".concat(props.reviews_link, "/notification?tab=").concat(props.main_link.includes('talk') ? 'talks' : 'reviews')
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/ic-notif.svg",
      width: "12",
      alt: "ic-notif",
      className: "ic-object"
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-search",
      on_click: props.show_search,
      element_id: props.search_button_id,
      type: props.type,
      aria_label: "Button Search"
    }), /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-cart",
      badge_count: props.total_cart_items,
      link: "".concat(props.shop_link, "/cart?action=show"),
      type: props.type,
      aria_label: "Button Cart"
    }), /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-notif",
      badge_count: props.total_unread_notif,
      link: "".concat(props.reviews_link, "/notification?tab=").concat(props.main_link.includes('talk') ? 'talks' : 'reviews'),
      element_id: props.button_notif_id,
      type: props.type,
      aria_label: "Button Notification"
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-search",
      on_click: props.show_search,
      element_id: props.search_button_id,
      type: props.type,
      aria_label: "Button Search"
    }), /*#__PURE__*/React.createElement(IconCTA, {
      is_mobile: props.is_mobile,
      icon_class: "fdicon-bs-cart",
      badge_count: 0,
      link: "".concat(props.shop_link, "/cart?action=show"),
      element_id: props.button_cart_id,
      type: props.type,
      aria_label: "Button Search"
    })))), !!props.childrenWrapper && /*#__PURE__*/React.createElement("div", {
      className: "child-component-wrapper"
    }, props.childrenWrapper), /*#__PURE__*/React.createElement("div", {
      className: "sidebar-wrapper".concat(props.is_show_sidebar ? ' show' : '')
    }, /*#__PURE__*/React.createElement(Sidebar, {
      is_mobile: props.is_mobile,
      logo_img: props.logo_img,
      menu: props.menu,
      self: props.self,
      is_fetch_complete: props.is_fetch_complete,
      main_link: props.main_link,
      reviews_link: props.reviews_link,
      sso_link: props.sso_link,
      logout_link: props.logout_link,
      onClickLogout: props.onClickLogout,
      close_sidebar: props.toggle_sidebar,
      button_login_id: props.button_login_id,
      config: props.sidebar_config,
      config_mommies: props.config_mommies,
      SisterSites: props.SisterSites,
      handle_category_list_sidebar: props.handle_category_list_sidebar,
      element_id_category: props.element_id_category,
      user_completing_precentage: props.user_completing_precentage,
      handleButtonVerif: props.handleButtonVerif,
      is_user_verified: props.is_user_verified,
      isShowDownloadApp: props.isShowDownloadApp,
      home_link: props.home_link,
      type: props.type,
      profile_link: props.profile_link,
      setting_link: props.setting_link,
      loggedInMenu: props.loggedInMenu,
      isShowAllo: props.isShowAllo,
      isAlloWalletLoading: props.isAlloWalletLoading,
      onClickLoginSignup: props.onClickLoginSignup,
      handleAlloExplorer: props.handleAlloExplorer,
      onClickAlloBalance: props.onClickAlloBalance,
      onClickAlloPoint: props.onClickAlloPoint,
      onClickAlloCoupons: props.onClickAlloCoupons
      //Sidebar dataDrawer
      ,
      dataDrawer: props.dataDrawer,
      handleMenuDrawer: props.handleMenuDrawer,
      ActiveMenuDrawer: props.ActiveMenuDrawer,
      alloBalanceText: props.alloBalanceText,
      MPCPointsText: props.MPCPointsText,
      MyCouponsText: props.MyCouponsText,
      profilePopupCustomElement: props.profilePopupCustomElement,
      brandsLink: props.brandsLink,
      elementIdBrands: props.elementIdBrands,
      onClickBrand: props.onClickBrand
    }))), /*#__PURE__*/React.createElement("style", null, "\n          .ic-object {\n            pointer-events: none;\n          }\n          .new-list-icon {\n            gap: 12px;\n            display: flex;\n          }\n          .new-icon {\n            width: 28px;\n            height: 28px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: none;\n            background: none;\n          }\n          .navbar-header-placeholder {\n            height: ".concat(props.nav_position === 'fixed' ? props.nav_height : '0', "px;\n            transition: all .2s ease;\n          }\n          .navbar-header {\n            position: ").concat(props.nav_position === 'fixed' ? 'fixed' : 'relative', ";\n            top: 0;\n            left: 0;\n            width: 100vw;\n            z-index: 3;\n            background-color: #FFF;\n            box-shadow: 0px 4px 10px rgba(145, 158, 171, 0.1);\n            transition: all .3s ease;\n          }\n\n          .navbar-content-wrapper {\n            display: flex;\n            align-items: center;\n            flex-wrap: wrap;\n            position: relative;\n            padding: 15px;\n          }\n\n          .burger-menu {\n            position: relative;\n            display: block;\n            margin-right: 15px;\n            height: 28px;\n            width: 28px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n\n          .header-right-menu {\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            margin-left: auto;\n          }\n\n          .header-right-menu .header-cta-wrapper,\n          .profile-menu-wrapper .header-cta-wrapper {\n            margin-left: 12px;\n          }\n\n          .header-right-menu .header-cta.wrapper:nth-child(1),\n          .profile-menu-wrapper .header-cta-wrapper:nth-child(1) {\n            margin-right: 0;\n          }\n\n          .profile-menu-wrapper {\n            display: flex;\n            align-items: center;\n            margin-left: 0;\n          }\n          \n          .search-suggestion-wrapper {\n            position: absolute;\n            top: 100%;\n            width: 100%;\n            left: 0;\n            display: none;\n            max-height: calc(100vh - 62px);\n            overflow-y: scroll;\n          }\n\n          .search-suggestion-wrapper.show {\n            display: block;\n          }\n\n          .child-component-wrapper {\n            width: 100%;\n            margin: 10px 0 0 0;\n          }\n\n          .sidebar-wrapper {\n            position: fixed;\n            top: 0;\n            left: -100vw;\n            transition: all .3s ease;\n          }\n\n          .sidebar-wrapper .sidebar {\n            position: relative;\n          }\n\n          .sidebar-wrapper.show {\n            left: 0;\n          }\n\n          ").concat(props.is_show_sidebar ? "body, html {\n                width: 100%;\n                height: 100vh;\n                margin: 0px;\n                overflow: hidden;\n              }" : '', "\n\n          .top-event-banner-url,\n          .top-event-banner-image {\n            display: block;\n            width: 100%;\n          }\n          .search-wrapper__container {\n            background: #FFF;\n            width: 100%;\n            height: 100%;\n            overflow-y: auto;\n            overflow-x: hidden;\n          }\n          .search-wrapper__container::-webkit-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper__container::-webkit-scrollbar-track {\n            background: #D9D9D9;\n          }\n          .search-wrapper__container::-webkit-scrollbar-thumb {\n            background: #D9D9D9;\n          }\n          .search-wrapper__container::-moz-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper__container::-moz-scrollbar-track {\n            background: #D9D9D9;\n          }\n          .search-wrapper__container::-moz-scrollbar-thumb {\n            background: #D9D9D9;\n          }\n          .search-wrapper__container::-ms-scrollbar {\n            width: 6px;\n          }\n          .search-wrapper__container::-ms-scrollbar-track {\n            background: #D9D9D9;\n          }\n          .search-wrapper__container::-ms-scrollbar-thumb {\n            background: #D9D9D9;\n          }\n        "))));
  };

  var NavbarHeader = /*#__PURE__*/function (_React$Component) {
    _inherits(NavbarHeader, _React$Component);
    var _super = _createSuper(NavbarHeader);
    function NavbarHeader(props) {
      var _this;
      _classCallCheck(this, NavbarHeader);
      _this = _super.call(this, props);
      _this.state = {
        is_show_popup_profile: false,
        search_text: '',
        is_show_search: false,
        is_show_sidebar: false,
        navbarHeight: 0,
        is_category_menu_open: false,
        is_category_sidebar_open: false,
        UrlRedirect: ''
      };
      _this.show_popup_profile = _this.show_popup_profile.bind(_assertThisInitialized(_this));
      _this.hide_popup_profile = _this.hide_popup_profile.bind(_assertThisInitialized(_this));
      _this.update_search_text = _this.update_search_text.bind(_assertThisInitialized(_this));
      _this.submit_search = _this.submit_search.bind(_assertThisInitialized(_this));
      _this.toggle_sidebar = _this.toggle_sidebar.bind(_assertThisInitialized(_this));
      _this.show_search = _this.show_search.bind(_assertThisInitialized(_this));
      _this.hide_search = _this.hide_search.bind(_assertThisInitialized(_this));
      _this.find_children = _this.find_children.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(NavbarHeader, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (document.getElementsByClassName('navbar-header').length > 0 && this.props.nav_position === 'fixed' && document.getElementsByClassName('navbar-header-placeholder')[0].offsetHeight === 0) {
          this.setState({
            navbarHeight: document.getElementsByClassName('navbar-header')[0].offsetHeight
          });
        }
        this.setState({
          UrlRedirect: window.location.href
        });
      }
    }, {
      key: "find_children",
      value: function find_children(payload) {
        var result = React.Children.toArray(this.props.children).find(function (child) {
          return child.type === payload;
        });
        return result;
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props,
          state = this.state;
        var searchWrapper = this.find_children(NavbarHeader.SearchWrapper) || null;
        var childrenWrapper = this.find_children(NavbarHeader.ChildrenWrapper) || null;
        if (!props.is_mobile) {
          return /*#__PURE__*/React.createElement(Desktop
          // determine type, style, and layout
          , {
            is_mobile: props.is_mobile // return desktop or mobile version
            ,
            nav_width: props.nav_width // navbar container width
            ,
            nav_height: props.nav_height || state.navbarHeight // navbar placeholder height
            ,
            nav_position: props.nav_position // navbar position on page. "fixed" or default null
            ,
            type: props.type // navbar style "monochrome" or default null
            //custom content
            ,
            children: props.children // everything below navbar header main content
            ,
            logo_img: props.logo_img // custom logo, should use image
            ,
            menu: props.menu // top menu array object
            ,
            customIcons: props.customIcons // icon(s) beside button profile
            ,
            handleClickCustomIcons: props.handleClickCustomIcons // can be null or not, based on customIcons props
            ,
            loggedInMenu: props.loggedInMenu || null // menu on profile popup and sidebar
            ,
            eventImage: props.eventImage || null // ribbon banner above navbar header main content
            ,
            eventURL: props.eventURL || null // link for ribbon banner above navbar header main content
            ,
            is_hide_top_menu: props.is_hide_top_menu // condition for top menu show or hide
            ,
            onClickLoginSignup: props.onClickLoginSignup // custom function on click button login / signup
            // user data management
            ,
            self: props.self // user's data
            ,
            is_fetch_complete: props.is_fetch_complete,
            is_show_popup_profile: props.is_show_popup_profile || state.is_show_popup_profile // condition for profile popup show or not
            ,
            show_popup_profile: props.show_popup_profile || this.show_popup_profile // function show popup profile
            ,
            hide_popup_profile: props.hide_popup_profile || this.hide_popup_profile // function hide popup profile
            ,
            hover_out_profile: props.hover_out_profile || this.hide_popup_profile // function on mouse out profile popup
            ,
            is_user_verified: props.is_user_verified // set user verified condition
            ,
            total_unread_notif: props.total_unread_notif // total user's notification
            ,
            total_cart_items: props.total_cart_items // total user's cart items
            ,
            profilePopupCustomElement: props.profilePopupCustomElement // custom element below profile section on profile popup
            // search management
            ,
            search_text: props.search_text || state.search_text // search text value
            ,
            submit_search: props.submit_search || this.submit_search // function on submit or enter key search input
            ,
            update_search_text: props.update_search_text || this.update_search_text // function set search text, can be useful for submit search
            ,
            goto_altoshift: props.goto_altoshift // function tracking on click search product card
            ,
            session_id: props.session_id // tracker id for google analytic, will be set for goto_altoshift function
            ,
            onBlurInput: props.onBlurInput || null // event listener on focus out search input
            ,
            searchContent: props.searchContent || null // custom content on search suggest, will replace default content
            // urls
            ,
            main_link: props.main_link // main link to determine show contents inside navbar
            ,
            sso_link: props.sso_link // login / logout link
            ,
            reviews_link: props.reviews_link // fdbr link
            ,
            shop_link: props.shop_link // commerce link
            ,
            home_link: props.home_link // fdnhome link
            ,
            talk_link: props.talk_link // community link
            ,
            profile_link: props.profile_link // // link profile popup and sidebar to user's page
            ,
            setting_link: props.setting_link || props.sso_link + '/my/account' // link profile popup and sidebar to user's setting page
            ,
            logout_link: props.logout_link || props.sso_link + '/logout' // logout url
            ,
            onClickLogout: props.onClickLogout
            // button id
            ,
            logo_id: props.logo_id // main logo element id
            ,
            search_input_id: props.search_input_id // search input id
            ,
            search_button_id: props.search_button_id // icon "magnification" id
            ,
            button_login_id: props.button_login_id // button login signup id
            ,
            button_notif_id: props.button_notif_id // icon "bell" id
            ,
            button_cart_id: props.button_cart_id // icon "cart" id
            // Allo button management
            ,
            handleAlloExplorer: props.handleAlloExplorer // for handling button allo explore
            ,
            isNewIcon: props.isNewIcon,
            searchWrapper: searchWrapper,
            search_on_input: props.search_on_input,
            search_on_change: props.search_on_change,
            search_on_focus: props.search_on_focus,
            search_on_select: props.search_on_select,
            search_on_keyDown: props.search_on_keydown,
            search_on_click: props.search_on_click,
            search_on_doubleclick: props.search_on_doubleclick,
            search_on_mouseenter: props.search_on_mouseenter,
            search_on_mouseleave: props.search_on_mouseleave,
            search_on_mouseover: props.search_on_mouseover,
            search_on_mouseout: props.search_on_mouseout,
            search_on_copy: props.search_on_copy,
            search_on_cut: props.search_on_cut,
            search_on_paste: props.search_on_paste,
            search_placeholder: props.search_placeholder,
            childrenWrapper: childrenWrapper,
            close_search_wrapper: props.close_search_wrapper
          });
        } else {
          return /*#__PURE__*/React.createElement(Mobile
          // determine type, style, and layout
          , {
            is_mobile: props.is_mobile // return desktop or mobile version
            ,
            nav_position: props.nav_position // navbar position on page. "fixed" or default null
            ,
            nav_height: props.nav_height || state.navbarHeight // navbar placeholder height, only can be used on nav_position fixed
            ,
            type: props.type // navbar style "monochrome" or default null
            //custom content
            ,
            children: props.children // everything below navbar header main content
            ,
            logo_img: props.logo_img // custom logo, should use image
            ,
            menu: props.menu // sidebar's menu array object, same as top menu array object placed bottom of sidebar
            ,
            customIcons: props.customIcons // icon(s) beside button profile
            ,
            handleClickCustomIcons: props.handleClickCustomIcons // can be null or not, based on customIcons props
            ,
            loggedInMenu: props.loggedInMenu || null // menu on profile popup and sidebar
            ,
            eventImage: props.eventImage || null // ribbon banner above navbar header main content
            ,
            eventURL: props.eventURL || null // link for ribbon banner above navbar header main content
            ,
            show_toast_cta: props.show_toast_cta // boolean for show modal cta
            ,
            text_toast_cta: props.text_toast_cta // toast cta's title
            ,
            handle_close_toast_cta: props.handle_close_toast_cta // function close modal cta
            ,
            sidebar_config: props.sidebar_config // list url below main logo
            ,
            config_mommies: props.sidebar_mommies // list url below main logo
            ,
            SisterSites: props.SisterSites // list of sister sites
            ,
            is_show_sidebar: props.is_show_sidebar || state.is_show_sidebar // boolean to determine show / hide sidebar
            ,
            toggle_sidebar: props.toggle_sidebar || this.toggle_sidebar // function to set sidebar show / hide
            ,
            handle_category_list_sidebar: props.handle_category_list_sidebar,
            onClickLoginSignup: props.onClickLoginSignup // custom function on click button login / singup
            // user data management
            ,
            self: props.self // user's data
            ,
            is_fetch_complete: props.is_fetch_complete,
            is_user_verified: props.is_user_verified // set user verified condition
            ,
            total_unread_notif: props.total_unread_notif // total user's notification
            ,
            total_cart_items: props.total_cart_items // total user's cart items
            ,
            profilePopupCustomElement: props.profilePopupCustomElement // custom element below profile section on profile popup
            ,
            user_completing_precentage: props.user_completing_precentage // user completing percetage, to determine handleButtonVerif
            ,
            handleButtonVerif: props.handleButtonVerif // function for redirect user from page product matches / sso
            // search management
            ,
            search_text: props.search_text // search text value
            ,
            is_show_search: props.is_show_search || state.is_show_search // set search visibility on mobile (replace content top navbar with search input)
            ,
            submit_search: props.submit_search || this.submit_search // function on submit or enter key search input
            ,
            update_search_text: props.update_search_text || this.update_search_text // function set search text, can be useful for submit search
            ,
            show_search: props.show_search || this.show_search // set true for is_show_search
            ,
            hide_search: props.hide_search || this.hide_search // set false for is_show_search
            ,
            goto_altoshift: props.goto_altoshift // function tracking on click search product card
            ,
            session_id: props.session_id // tracker id for google analytic, will be set for goto_altoshift function
            ,
            onBlurInput: props.onBlurInput || null // event listener on focus out search input
            ,
            searchContent: props.searchContent || null // custom content on search suggest, will replace default content
            // urls
            ,
            main_link: props.main_link // main link to determine show contents inside navbar
            ,
            url_play_store: props.url_play_store // url to fd app's play store
            ,
            url_apps_store: props.url_apps_store // url to fd app's app store
            ,
            sso_link: props.sso_link // login / logout link
            ,
            reviews_link: props.reviews_link // fdbr link
            ,
            shop_link: props.shop_link // commerce link
            ,
            home_link: props.home_link // fdnhome link
            ,
            talk_link: props.talk_link // community link
            ,
            profile_link: props.profile_link // // link profile popup and sidebar to user's page
            ,
            setting_link: props.setting_link || props.sso_link + '/my/account' // link profile popup and sidebar to user's setting page
            ,
            logout_link: props.logout_link || props.sso_link + '/logout',
            onClickLogout: props.onClickLogout
            // button id
            ,
            logo_id: props.logo_id // main logo element id
            ,
            search_input_id: props.search_input_id // search input id
            ,
            search_button_id: props.search_button_id // icon "magnification" id
            ,
            button_login_id: props.button_login_id // button login signup id
            ,
            button_notif_id: props.button_notif_id // icon "bell" id
            ,
            button_cart_id: props.button_cart_id // icon "cart" id
            ,
            element_id_btn_close_toast_cta: props.element_id_btn_close_toast_cta // icon close on modal cta
            ,
            element_id_btn_install_toast_cta: props.element_id_btn_install_toast_cta // url id for button cta
            // Allo button management
            ,
            handleAlloExplorer: props.handleAlloExplorer // for handling button allo explore
            //Sidebar dataDrawer
            ,
            dataDrawer: props.dataDrawer,
            handleMenuDrawer: props.handleMenuDrawer,
            ActiveMenuDrawer: props.ActiveMenuDrawer,
            isNewIcon: props.isNewIcon,
            searchWrapper: searchWrapper,
            search_on_input: props.search_on_input,
            search_on_change: props.search_on_change,
            search_on_focus: props.search_on_focus,
            search_on_select: props.search_on_select,
            search_on_keyDown: props.search_on_keydown,
            search_on_click: props.search_on_click,
            search_on_doubleclick: props.search_on_doubleclick,
            search_on_mouseenter: props.search_on_mouseenter,
            search_on_mouseleave: props.search_on_mouseleave,
            search_on_mouseover: props.search_on_mouseover,
            search_on_mouseout: props.search_on_mouseout,
            search_on_copy: props.search_on_copy,
            search_on_cut: props.search_on_cut,
            search_on_paste: props.search_on_paste,
            search_placeholder: props.search_placeholder,
            childrenWrapper: childrenWrapper,
            brandsLink: props.brandsLink,
            elementIdBrands: props.elementIdBrands,
            onClickBrand: props.onClickBrand
          });
        }
      }
    }, {
      key: "show_popup_profile",
      value: function show_popup_profile() {
        this.setState({
          is_show_popup_profile: true
        });
      }
    }, {
      key: "hide_popup_profile",
      value: function hide_popup_profile(e) {
        var _e$relatedTarget;
        if (e !== null && e !== void 0 && e.relatedTarget && (e === null || e === void 0 || (_e$relatedTarget = e.relatedTarget) === null || _e$relatedTarget === void 0 ? void 0 : _e$relatedTarget.className) !== 'profile-detail') {
          this.setState({
            is_show_popup_profile: false
          });
        }
      }
    }, {
      key: "update_search_text",
      value: function update_search_text(e) {
        if ((e === null || e === void 0 ? void 0 : e.keyCode) === 13) {
          this.submit_search(e);
        } else {
          var _e$target;
          this.setState({
            search_text: e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value
          });
        }
      }
    }, {
      key: "submit_search",
      value: function submit_search(e) {
        if (e) {
          e.preventDefault();
        }
        if (this.state.search_text !== '') {
          document.location.href = "".concat(this.props.reviews_link, "/search/").concat(encodeURIComponent(this.state.search_text), "?tab=all");
        }
      }
    }, {
      key: "toggle_sidebar",
      value: function toggle_sidebar() {
        this.setState({
          is_show_sidebar: !this.state.is_show_sidebar
        });
      }
    }, {
      key: "show_search",
      value: function show_search() {
        this.setState({
          is_show_search: true
        });
      }
    }, {
      key: "hide_search",
      value: function hide_search() {
        this.setState({
          is_show_search: false
        });
      }
    }]);
    return NavbarHeader;
  }(React.Component);
  NavbarHeader.SearchWrapper = function (_ref) {
    var children = _ref.children;
    return children;
  };
  NavbarHeader.ChildrenWrapper = function (_ref2) {
    var children = _ref2.children;
    return children;
  };
  NavbarHeader.defaultProps = {
    is_mobile: false,
    nav_width: '1200px',
    type: null,
    nav_position: null,
    is_hide_top_menu: false,
    is_user_verified: null,
    show_toast_cta: false,
    isShowAllo: false,
    is_fetch_complete: true,
    text_toast_cta: 'Get the best beauty experience for you in Female Daily App!',
    url_play_store: 'https://play.google.com/store/apps/details?id=com.fdbr.android&hl=en_GB',
    url_apps_store: 'https://apps.apple.com/id/app/female-daily-beauty-review/id1160742672?l=id',
    search_text: '',
    sso_link: '//account.femaledaily.com',
    reviews_link: '//reviews.femaledaily.com',
    shop_link: '//studio.femaledaily.com',
    home_link: '//femaledaily.com',
    talk_link: '//femaledaily.com',
    profile_link: '//account.femaledaily.com',
    session_id: '',
    menu: null,
    self: null,
    sidebar_config: [],
    config_mommies: [],
    SisterSites: [{
      name: 'Mommies Daily',
      value: 'md',
      pathname: '//mommiesdaily.com/',
      query: '',
      visible: true,
      "new": false
    }, {
      name: 'Beauty Studio',
      value: 'bs',
      pathname: '//studio.femaledaily.com/',
      query: '',
      visible: true,
      "new": false
    }, {
      name: 'Girls Beyond',
      value: 'gb',
      pathname: '//girlsbeyond.com/',
      query: '',
      visible: true,
      "new": true
    }],
    ActiveMenuDrawer: [],
    dataDrawer: [],
    main_link: null,
    logo_id: null,
    search_input_id: null,
    search_button_id: null,
    button_login_id: null,
    button_notif_id: null,
    button_cart_id: null,
    element_id_btn_close_toast_cta: null,
    element_id_btn_install_toast_cta: null,
    total_unread_notif: 0,
    total_cart_items: 0,
    user_completing_precentage: 100,
    customIcons: null,
    isShowDownloadApp: false,
    isNewIcon: false,
    onClickLogout: null,
    profilePopupCustomElement: null,
    init_auto_search: function init_auto_search() {
      return false;
    },
    goto_altoshift: function goto_altoshift() {
      return false;
    },
    handleButtonVerif: function handleButtonVerif() {
      return false;
    },
    handle_close_toast_cta: function handle_close_toast_cta() {
      return false;
    },
    handle_category_list_sidebar: function handle_category_list_sidebar() {
      return false;
    },
    onClickAlloBalance: function onClickAlloBalance() {
      return false;
    },
    onClickAlloPoint: function onClickAlloPoint() {
      return false;
    },
    onClickAlloCoupons: function onClickAlloCoupons() {
      return false;
    },
    handleAlloExplorer: function handleAlloExplorer() {
      return false;
    },
    handleMenuDrawer: function handleMenuDrawer() {
      return false;
    },
    close_search_wrapper: function close_search_wrapper() {
      return false;
    },
    search_on_input: function search_on_input() {},
    search_on_change: function search_on_change() {},
    search_on_focus: function search_on_focus() {},
    search_on_select: function search_on_select() {},
    search_on_keydown: function search_on_keydown() {},
    search_on_click: function search_on_click() {},
    search_on_doubleclick: function search_on_doubleclick() {},
    search_on_mouseenter: function search_on_mouseenter() {},
    search_on_mouseleave: function search_on_mouseleave() {},
    search_on_mouseover: function search_on_mouseover() {},
    search_on_mouseout: function search_on_mouseout() {},
    search_on_copy: function search_on_copy() {},
    search_on_cut: function search_on_cut() {},
    search_on_paste: function search_on_paste() {},
    brandsLink: "#",
    elementIdBrands: "id_brands",
    handle_on_click_brand: undefined,
    logo_img: 'https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-femaledaily.svg'
  };

  return NavbarHeader;

})));
//# sourceMappingURL=navbar_header.umd.js.map
